module.exports = __webpack_public_path__ + "img/people.e8327262.svg";